/*
 *
 * CrossPiecePanel actions
 *
 */

import { action } from 'typesafe-actions';

import ActionTypes from './constants';
import { CrossPieceType, Position } from '../../lib/modelBuilder/constants';

export const addOrUpdateCrossPieceAction = (
  positionCP: Position,
  inferior: boolean,
  crossPieceType: CrossPieceType,
  reinforce: boolean,
  preview = false,
  drill = false,
) =>
  action(ActionTypes.ADD_OR_UPDATE_CROSS_PIECE, {
    positionCP,
    inferior,
    crossPieceType,
    reinforce,
    preview,
    drill,
  });

export const removeCrossPieceAction = (
  positionCP: Position,
  inferior: boolean,
) =>
  action(ActionTypes.REMOVE_CROSS_PIECE, {
    positionCP,
    inferior,
  });
